import { Injectable, EventEmitter } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class WeekSwitcherService {
    weekArray: moment.Moment[] = [];
    weekChanged = new EventEmitter();

    constructor() {
        this.initializeForCurrentDate();
    }

    getStartOfSelectedWeek(): moment.Moment {
        return this.weekArray[0];
    }

    getEndOfSelectedWeek(): moment.Moment {
        return this.weekArray[6];
    }

    initializeForCurrentDate() {
        let today = moment().startOf('day');

        let daysToAdd = 1 - today.day();

        this.updateArrayForGivenDate(today, daysToAdd);
    }

    goToNextWeek() {
        this.updateArrayForGivenDate(this.weekArray[0].add(7, 'day'), 0);
        this.weekChanged.emit();
    }

    goToPreviousWeek() {
        this.updateArrayForGivenDate(this.weekArray[0].subtract(7, 'day'), 0);
        this.weekChanged.emit();
    }

    goToCurrentWeek() {
        this.initializeForCurrentDate();
        this.weekChanged.emit();
    }

    goToWeekOf(destination: string | moment.Moment) {
        let date = moment(destination).startOf('day');

        let daysToAdd;
        if (date.day() === 0) {
            daysToAdd = -6;
        } else {
            daysToAdd = 1 - date.day();
        }

        if (!this.addDaysToDate(date, daysToAdd).isSame(this.weekArray[0])) {
            this.updateArrayForGivenDate(date, daysToAdd);
            this.weekChanged.emit();
        }
    }

    private updateArrayForGivenDate(date: moment.Moment, daysToAdd: number) {
        this.weekArray = [];
        for (let i = 0; i < 7; i++) {
            this.weekArray.push(this.addDaysToDate(date, daysToAdd));
            daysToAdd++;
        }
    }

    private addDaysToDate(date: moment.Moment, days: number): moment.Moment {
        let newDate = moment(date).startOf('day');
        newDate.add(days, 'day');

        return newDate;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/week-switcher.service.ts